import React from 'react';
import Radio from '@mui/material/Radio';
import Box from '@mui/material/Box';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormHelperText from '@mui/material/FormHelperText';
import Typography from '@mui/material/Typography';

const CustomRadio = ({
  label = '',
  value,
  checked,
  onChange,
  name,
  hasError,
  hint,
  helpText,
  disabled,
  color,
  size,
  ...rest
}) => {
  return (
    <Box {...rest}>
      <FormControlLabel
        disabled={disabled}
        name={name}
        onChange={onChange}
        value={value}
        checked={checked}
        control={<Radio size={size} color={color} />}
        label={label}
      />
      {hasError && <FormHelperText>{helpText}</FormHelperText>}
      {hint && (
        <Typography
          component="div"
          variant="caption"
          sx={{ paddingLeft: 3.5 }}
          color="textSecondary"
        >
          {hint}
        </Typography>
      )}
    </Box>
  );
};

export default CustomRadio;
